module.exports = __webpack_public_path__ + "google_pixel-black-landscape@2x.png?f9ab7ca1346ed05b0271de4f8e902007";